import React from 'react';
import { I_TodayMoreGroup } from '@Redux/detail/Group/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import DirectionList from './DirectionList';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { useTranslation } from 'react-i18next';
import { I_DirectionList as I_DirectionListSearch } from '@Redux/search/interfaces';
import { I_DirectionList as I_DirectionListDetail } from '@Redux/detail/Group/interfaces';
import { I_DirectionList as I_DirectionListPrint } from '@Redux/print/Group/interfaces';

interface I_Props {
    GroupList?: I_TodayMoreGroup[];
    directionList: I_DirectionListSearch[] | I_DirectionListDetail[] | I_DirectionListPrint[] | undefined;
}

function GroupList({ directionList }: I_Props) {
    const { t } = useTranslation();
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    return (
        <ul className={styles.groupList}>
            <li className={cN(styles.group, [isPrint ? 'flight-group' : ''])}>
                {Array.isArray(directionList) && directionList.length > 0 && (
                    <div className={styles.flights}>
                        {directionList.map((direction, i) => {
                            return <DirectionList key={i} direction={direction} />
                        })}
                    </div>
                )}
            </li>
        </ul>
    );
}

export default GroupList;
